import Box from "@mui/material/Box";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";

const CreateFsModal = (props) => {
  const {
    open,
    handleClose,
    handleChangeValue,
    allCompany,
    selectedIr,
    uploadPreset,
    uploadPresetID,
    handleSubmitFs,
    workspaceData,
    ProjectName,
    fsData,
    projectsData,
    setUploadPresetId,
    consolList,          // ✅ NEW: received from parent (allpreconsoldata)
  } = props;

  const [parentOpt, setParentOpt] = useState([]);
  const [irOpt, setIROpt] = useState([]);
  const [presetOpts, setPresetOpts] = useState([]);
  const [currentFY, setCurrentFY] = useState(null);
  const [previousFY, setPreviousFY] = useState(null);
  const [selectedOption, setSelectedOption] = useState("uploadPreset");
  const [existingConsolOpts, setExistingConsolOpts] = useState([]);

  // ✅ Populate Investment Register options
  useEffect(() => {
    if (selectedIr?.length > 0) {
      const opt2 = selectedIr.map((det) => ({
        label: det.name,
        value: det._id,
      }));
      setIROpt(opt2);
    } else {
      setIROpt([]);
    }
  }, [selectedIr]);

  // ✅ Populate Preset options
  useEffect(() => {
    if (projectsData?.length > 0) {
      const options = projectsData.map((det) => ({
        label: det.project_name,
        value: det._id,
      }));
      setPresetOpts(options);
    }
  }, [projectsData]);

  // ✅ Populate Existing Consol options from consolList prop
  useEffect(() => {
    if (consolList?.length > 0) {
      const options = consolList.map((det) => ({
        label: det.name,
        value: det._id,
      }));
      setExistingConsolOpts(options);
    } else {
      setExistingConsolOpts([]);
    }
  }, [consolList]);


  useEffect(() => {
    if (allCompany?.length > 0) {
      const opt1 = allCompany.map((det) => ({
        label: det.company_name,
        value: det._id,
      }));
      setParentOpt(opt1);
    }
  }, [allCompany]);

  const handleRadioChange = (value) => {
  setSelectedOption(value);

  if (value === "uploadPreset") {
    handleChangeValue("standalone", "FSType"); 
    handleChangeValue("", "consolID");
  } else {
    handleChangeValue("consol", "FSType");   
    setUploadPresetId("");
    handleChangeValue("", "consolID");
  }
};

  return (
    <>
      {open && (
        <Modal
          title="Create Consol FS"
          bodycss={commoncss.unsetPadding}
          width="40%"
          headerActions={
            <CloseIcon onClick={handleClose} className="clickable" />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleClose}
                label="Cancel"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Create Consol FS"
                onClick={handleSubmitFs}
              />
            </>
          }
        >
          <div className={commoncss.pd1530}>

            {/* Consol Name */}
            <InputGroup
              class_="mb-2"
              label="Consol Name"
              inputs={[
                <input
                  key="consol_name"
                  name="tag"
                  placeholder="Enter Consol Name"
                  onChange={(e) => handleChangeValue(e.target.value, "consol_name")}
                  value={fsData?.consol_name || ""}
                />,
              ]}
            />

            {/* Parent Company */}
            <Dropdown
              label="Parent Company"
              options={parentOpt}
              onSelect={(opt) => handleChangeValue(opt.value, "parent_company")}
              placeHolder="Select Parent Company"
            />

            {/* Investment Register */}
            <Dropdown
              label="Investment Register"
              options={irOpt}
              onSelect={(opt) => handleChangeValue(opt.value, "link_ir")}
              placeHolder="Select Investment Register"
            />

        
            <div style={{ margin: "20px 0" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px" }}>
                <div style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
                  Select an option
                </div>
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "500",
                      cursor: "pointer",
        
                    }}
                  >
                    <input
                      type="radio"
                      name="fsSelection"
                      value="uploadPreset"
                      checked={selectedOption === "uploadPreset"}
                      onChange={(e) => handleRadioChange(e.target.value)}
                      style={{ marginRight: "8px" }}
                    />
                    Upload Preset
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="fsSelection"
                      value="existingConsol"
                      checked={selectedOption === "existingConsol"}
                      onChange={(e) => handleRadioChange(e.target.value)}
                      style={{ marginRight: "8px" }}
                    />
                    Select Existing Consol FS
                  </label>

                </div>
              </div>

              {/* ✅ Upload Preset Dropdown */}
              {selectedOption === "uploadPreset" && (
                <Dropdown
                  label=""
                  options={presetOpts}
                  onSelect={(opt) => {
                    setUploadPresetId(opt.value);
                  }}
                  placeHolder="Select Preset"
                />
              )}

              {/* ✅ Existing Consol Dropdown — sends consolID to parent */}
              {selectedOption === "existingConsol" && (
                <Dropdown
                  label=""
                  options={existingConsolOpts}
                  onSelect={(opt) => handleChangeValue(opt.value, "consolID")}
                  placeHolder="Select Existing Consol FS"
                />
              )}
            </div>

            {/* Financial Year Pickers */}
            <InputGroup
              inputs={[
                <InputGroup
                  key="currentFY"
                  label="Current financial year"
                  inputs={[
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                          <MobileDatePicker
                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                            value={currentFY}
                            onChange={(value) => {
                              if (!value) return;
                              setCurrentFY(value);
                              const formatted = value.format("YYYY-MM-DD");
                              console.log("Current FY:", formatted);
                              handleChangeValue(formatted, "current_yr");
                            }}
                            format="DD-MMM-YYYY"
                            slotProps={{
                              textField: {
                                InputProps: { disableUnderline: true },
                                sx: { "& fieldset": { border: "none" } },
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div style={{ pointerEvents: "none" }}>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                            style={{ cursor: "pointer", pointerEvents: "auto" }}
                          />
                        </span>
                      </div>
                    </>,
                  ]}
                />,

                <InputGroup
                  key="previousFY"
                  label="Previous financial year"
                  inputs={[
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                          <MobileDatePicker
                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                            value={previousFY}
                            onChange={(value) => {
                              if (!value) return;
                              setPreviousFY(value);
                              const formatted = value.format("YYYY-MM-DD");
                              console.log("Previous FY:", formatted);
                              handleChangeValue(formatted, "previous_yr");
                            }}
                            format="DD-MMM-YYYY"
                            slotProps={{
                              textField: {
                                InputProps: { disableUnderline: true },
                                sx: { "& fieldset": { border: "none" } },
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div style={{ pointerEvents: "none" }}>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                            style={{ cursor: "pointer", pointerEvents: "auto" }}
                          />
                        </span>
                      </div>
                    </>,
                  ]}
                />,
              ]}
            />

          </div>
        </Modal>
      )}
    </>
  );
};

export default CreateFsModal;